// Waypoint to close events filter when scrolled away
const events = document.querySelector(".m-news-events");

if (events) {
  const body = document.body;

  new Waypoint({
    element: events,
    handler: function (direction) {
      if (direction === "up") {
        body.classList.remove("events-filter-open");
      }
    },
    offset: "100%",
  });

  new Waypoint({
    element: events,
    handler: function (direction) {
      if (direction === "down") {
        body.classList.remove("events-filter-open");
      }
    },
    offset: function () {
      return -this.element.clientHeight;
    },
  });
}
